import { render, staticRenderFns } from "./AgendaTipologieVisitaListPage.vue?vue&type=template&id=0b2b0b19&scoped=true"
import script from "./AgendaTipologieVisitaListPage.vue?vue&type=script&lang=js"
export * from "./AgendaTipologieVisitaListPage.vue?vue&type=script&lang=js"
import style0 from "./AgendaTipologieVisitaListPage.vue?vue&type=style&index=0&id=0b2b0b19&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b2b0b19",
  null
  
)

export default component.exports